export default __webpack_public_path__ + "static/media/cib_jquery.6d4ad825.svg";